// src/SizeManager.jsx
import React, { useState, useEffect } from 'react';
import {
  Container,
  Typography,
  Paper,
  TextField,
  Button,
  Box,
  Stack,
  Switch,
  FormControlLabel,
} from '@mui/material';
import {
  collection,
  getDocs,
  setDoc,
  updateDoc,
  deleteDoc,
  doc,
} from 'firebase/firestore';
import { db } from './firebase'; // ✅ use the already-initialized instance

//const db = getFirestore();
const SIZE_COLLECTION = 'beverage_sizes';

const SizeManager = () => {
  const [sizes, setSizes] = useState([]);
  const [editing, setEditing] = useState(null);
  const [form, setForm] = useState({
    id: '',
    label: '',
    volume_oz: '',
    active: true,
  });

  const fetchSizes = async () => {
    const snapshot = await getDocs(collection(db, SIZE_COLLECTION));
    const data = snapshot.docs.map(doc => ({ docId: doc.id, ...doc.data() }));
    setSizes(data);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async () => {
    const { id, label, volume_oz, active } = form;
    if (!id || !label || !volume_oz) return;

    const data = {
      label,
      volume_oz: parseInt(volume_oz),
      active,
    };

    const ref = doc(db, SIZE_COLLECTION, id);
    editing ? await updateDoc(ref, data) : await setDoc(ref, data);

    await fetchSizes();
    setForm({ id: '', label: '', volume_oz: '', active: true });
    setEditing(null);
  };

  const handleEdit = (size) => {
    setEditing(size);
    setForm({
      id: size.docId,
      label: size.label,
      volume_oz: size.volume_oz,
      active: size.active,
    });
  };

  const handleDelete = async (id) => {
    await deleteDoc(doc(db, SIZE_COLLECTION, id));
    await fetchSizes();
  };

  useEffect(() => {
    fetchSizes();
  }, []);

  return (
    <Container maxWidth="sm" sx={{ py: 6 }}>
      <Typography variant="h4" align="center" gutterBottom>
        🧃 Size Manager
      </Typography>

      <Paper sx={{ p: 3, mb: 4 }} elevation={3}>
        <Stack spacing={2}>
          <TextField
            label="Size ID"
            name="id"
            value={form.id}
            onChange={handleChange}
            disabled={!!editing}
            helperText="e.g. size_12oz"
          />
          <TextField
            label="Label"
            name="label"
            value={form.label}
            onChange={handleChange}
            helperText="e.g. 12oz"
          />
          <TextField
            label="Volume (oz)"
            name="volume_oz"
            type="number"
            value={form.volume_oz}
            onChange={handleChange}
          />
          <FormControlLabel
            control={
              <Switch
                checked={form.active}
                onChange={(e) => setForm(prev => ({ ...prev, active: e.target.checked }))}
              />
            }
            label="Active"
          />
          <Button variant="contained" onClick={handleSubmit}>
            {editing ? 'Update Size' : 'Add Size'}
          </Button>
        </Stack>
      </Paper>

      <Typography variant="h6">📋 Existing Sizes</Typography>
      <Stack spacing={2} mt={2}>
        {sizes.map(size => (
          <Paper key={size.docId} sx={{ p: 2 }}>
            <Box display="flex" justifyContent="space-between">
              <div>
                <Typography fontWeight="bold">{size.label}</Typography>
                <Typography variant="caption">{size.docId}</Typography>
                <Typography variant="body2">Volume: {size.volume_oz} oz</Typography>
                {!size.active && <Typography color="error">Inactive</Typography>}
              </div>
              <Stack direction="row" spacing={1}>
                <Button size="small" onClick={() => handleEdit(size)}>Edit</Button>
                <Button size="small" color="error" onClick={() => handleDelete(size.docId)}>Delete</Button>
              </Stack>
            </Box>
          </Paper>
        ))}
      </Stack>
    </Container>
  );
};

export default SizeManager;
